import { Link } from 'react-router-dom';
import type { IntegrationPublic } from '@marketing-hub/shared';
import { INTEGRATION_CONNECTOR_LABELS } from '@marketing-hub/shared';
import { integrationStatusLabel } from '@/features/integrations/integrationHelp';
import styles from '../../pages/DashboardPage.module.css';

type Props = {
  integrations: IntegrationPublic[];
};

function formatSyncAt(iso: string | null): string {
  if (!iso) return 'nog niet';
  return new Date(iso).toLocaleString('nl-NL', { dateStyle: 'short', timeStyle: 'short' });
}

export function IntegrationStatusStrip({ integrations }: Props) {
  const ga4 = integrations.find((i) => i.connector_type === 'ga4');
  const gsc = integrations.find((i) => i.connector_type === 'gsc');
  if (!ga4 && !gsc) return null;

  const rows = [ga4, gsc].filter(Boolean) as IntegrationPublic[];

  return (
    <div className={styles.integrationStrip} role="status">
      {rows.map((i) => {
        const err = i.status === 'error';
        return (
          <div
            key={i.id}
            className={`${styles.integrationChip} ${err ? styles.integrationChipError : ''}`}
          >
            <strong>{INTEGRATION_CONNECTOR_LABELS[i.connector_type]}</strong>
            <span>{integrationStatusLabel(i.status)}</span>
            <span className={styles.integrationMeta}>Sync: {formatSyncAt(i.last_sync_at)}</span>
            {err ? (
              <span className={styles.integrationErr}>
                {i.last_error?.slice(0, 80) ?? 'Sync mislukt — Sync now bij Integraties'}
              </span>
            ) : null}
          </div>
        );
      })}
      <Link to="/app/integraties" className={styles.integrationLink}>
        Integraties →
      </Link>
    </div>
  );
}
